<template>
	<div>
		<h1><em class="fas fa-lock"></em> {{app_name}} Portal</h1>

		<div class="row">
			<div class="col-12 col-lg-6 mb-3">
				<div class="card text-center">
					<div class="card-header"><h2 class="m-0 p-0"><em class="fas fa-fw fa-key"></em> User Login</h2></div>

					<div class="card-body">
						<div class="form-row">
							<div class="alert alert-info d-block w-100" v-if="login_loading"><em class="fas fa-circle-notch fa-spin"></em> Please Wait...</div>
							<div class="alert alert-success d-block w-100" v-if="login_message">{{login_message}}</div>
							<div class="alert alert-danger d-block w-100" v-if="login_error">{{login_error}}</div>
						</div>

						<form method="post" v-on:submit.prevent="login()">
							<div class="form-row mb-2">
								<input type="text" v-model="creds.username" v-bind:disabled="login_loading == 1" placeholder="Username or Email Address" title="" class="form-control" aria-label="Your username is required." required autofocus autocomplete="off" />
							</div>

							<div class="form-row mb-2">
								<input type="password" id="password" v-model="creds.password" v-bind:disabled="login_loading == 1" placeholder="Password" title="Password" class="form-control" aria-label="Your password is required." required />
							</div>

							<div class="form-row">
								<button type="submit" class="btn btn-primary d-block w-100" v-bind:disabled="login_loading == 1"><em class="fas fa-fw fa-sign-in-alt" aria-hidden="true"></em> Authenticate</button>
							</div>
						</form>
					</div>
				</div>
			</div>

			<div class="col-12 col-lg-6 mb-3">
				<div class="card text-center">
					<div class="card-header"><h2 class="m-0 p-0"><em class="fas fa-fw fa-question-circle"></em> Forgot Your Password?</h2></div>

					<div class="card-body">
						<div class="form-row">
							<div class="alert alert-info d-block w-100" v-if="reset_loading"><em class="fas fa-circle-notch fa-spin"></em> Please Wait...</div>
							<div class="alert alert-success d-block w-100" v-if="reset_message">{{reset_message}}</div>
							<div class="alert alert-danger d-block w-100" v-if="reset_error">{{reset_error}}</div>
						</div>

						<form method="post" v-on:submit.prevent="passwordResetEmail" v-show="reset_step == 1">
							<div class="form-row mb-2">
								<input type="email" v-model="reset.email" v-bind:disabled="reset_step == 1 && reset_loading == 1" placeholder="Email Address" title="Email Address" class="form-control" aria-label="Your email address can be used to reset your password." required autocomplete="off" />
							</div>

							<div class="form-row mb-2">
								<input type="text" class="form-control" style="visibility: hidden" />
							</div>

							<div class="form-row">
								<button type="submit" class="btn btn-info d-block w-100" v-bind:disabled="reset_loading == 1">Continue <em class="fas fa-fw fa-arrow-right" aria-hidden="true"></em></button>
							</div>
						</form>

						<form method="post" v-on:submit.prevent="passwordReset" v-show="reset_step == 2">
							<div class="form-row mb-2">
								<input type="email" v-model="reset.email" v-bind:disabled="reset_loading == 1" placeholder="Email Address" title="Email Address" class="form-control" aria-label="Your email address can be used to reset your password." required autocomplete="off" />
							</div>

							<div class="form-row mb-2">
								<input type="text" id="password_reset_code" v-model="reset.code" v-bind:disabled="reset_loading == 1" placeholder="Password Reset Code" title="Password Reset Code" class="form-control" aria-label="You were emailed a password reset code." required autocomplete="off" />
							</div>

							<div class="form-row mb-2">
								<input type="password" v-model="reset.password" v-bind:disabled="reset_loading == 1" placeholder="New Password" title="New Password" class="form-control" aria-label="Enter your new password." required autocomplete="off" minlength="8" />
							</div>

							<div class="form-row">
								<button type="submit" class="btn btn-success d-block w-100" v-bind:disabled="reset_step == 2 && reset_loading == 1"><em class="fas fa-fw fa-magic" aria-hidden="true"></em> Reset Password</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Login',
	data() {
		return {
			creds: {username: "", password: ""},
			reset: {email: "", code: "", password: ""},
			login_loading: false,
			login_message: "",
			login_error: "",
			reset_loading: false,
			reset_message: "",
			reset_error: "",
			reset_step: 1
		}
	},
	methods:
	{
		login: function()
		{
			var vm = this;
			vm.login_message = "";
			vm.login_error = "";
			vm.login_loading = true;
			vm.startLoading();
			localStorage.clear();

			vm.CORS("POST", "/login", JSON.stringify(vm.creds),
				function(data)
				{
					vm.login_loading = false;
					vm.stopLoading();

					if(data.success == 1)
					{
						vm.$emit("login");
						vm.$router.push("/").catch(function() { /* ignore error */ });
					}
					else
					{
						vm.reset_error = "Login Failed";
					}
				},
				function(data)
				{
					vm.login_loading = false;
					vm.stopLoading();

					if(typeof data.responseJSON == "undefined")
					{
						vm.login_error = data;
					}
					else
					{
						vm.login_error = data.responseJSON.message;
					}
				});
		},
		passwordResetEmail: function()
		{
			var vm = this;
			vm.reset_message = "";
			vm.reset_error = "";
			vm.reset_loading = true;
			vm.startLoading();

			vm.CORS("POST", "/passwordReset", vm.reset,
				function(data)
				{
					vm.reset_loading = false;
					vm.stopLoading();

					if(data.success == 1)
					{
						vm.reset_message = data.message;
						vm.reset_step = 2;
						setTimeout(function()
						{
							document.getElementById("password_reset_code").focus();
						}, 500);
					}
					else
					{
						vm.reset_error = "Password Reset Failed";
					}
				},
				function(data)
				{
					vm.reset_loading = false;
					vm.stopLoading();

					if(typeof data.responseJSON == "undefined")
					{
						vm.reset_error = data;
					}
					else
					{
						vm.reset_error = data.responseJSON.message;
					}
				});
		},
		passwordReset: function()
		{
			var vm = this;
			vm.reset_message = "";
			vm.reset_error = "";
			vm.reset_loading = true;
			vm.startLoading();

			vm.CORS("PUT", "/passwordReset", vm.reset,
				function(data)
				{
					vm.reset_loading = false;
					vm.stopLoading();

					if(data.success == 1)
					{
						vm.reset_message = data.message;
						vm.reset_step = 3;
						vm.creds.email = data.email;
						vm.creds.password = vm.reset.password;

						setTimeout(function()
						{
							document.getElementById("password").focus();
						}, 500);
					}
					else
					{
						vm.reset_error = "Password Reset Failed";
					}
				},
				function(data)
				{
					vm.reset_loading = false;
					vm.stopLoading();

					if(typeof data.responseJSON == "undefined")
					{
						vm.reset_error = data;
					}
					else
					{
						vm.reset_error = data.responseJSON.message;
					}
				});
		}
	}
}
</script>
